<template>
  <v-row justify="center">
    <v-dialog v-model="localDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="fechar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Plano Bimestral</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-row>
          <v-col>
            <iframe :src="pdf" frameborder="0" style="min-height: 100vh; width: 100%"> </iframe>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    pdf: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      localDialog: this.dialog,
    };
  },
  watch: {
    dialog(val) {
      this.localDialog = val;
    },
    localDialog(val) {
      this.$emit("update:dialog", val);
    },
  },
  methods: {
    fechar() {
      this.localDialog = false;
    },
  },
};
</script>
